import { ApiError } from '@/@types/generated'
import { useNavigate, useParams } from 'react-router'
import { Params } from '@/routes'
import { TicketDetailsLayout } from '../components/TicketDetailsLayout'
import { TicketProvider } from '../hooks/ticket'
import { buildPath } from '@/routes'

export function TicketDetails() {
  // Hooks
  const { ticketId } = useParams<Params<'/tickets/:ticketId'>>()
  const navigate = useNavigate()

  const handleError = (error: unknown) => {
    // Redirect to cases index if not found
    if (error instanceof ApiError && error.status === 404) {
      navigate(buildPath('/tickets'))
    }
  }

  return (
    <TicketProvider id={ticketId} onError={handleError}>
      <TicketDetailsLayout />
    </TicketProvider>
  )
}
